
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";

@Component
export default class Categorias extends Mixins(FormValidator) {
  private horizontalPercentageComercios = 0;
  private categorias: Array<any> = [];
  private ultimosBeneficios: Array<any> = [];
  private bucket: any = "";
  private mounted() {
    this.bucket = process.env.VUE_APP_BASE_URL;
    this.getCategorias();
    this.getUltimosBeneficios();
    this.autoscrollComercios();
  }

  private getUltimosBeneficios() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("/beneficios/ultimos")
      .then((res: any) => {
        this.ultimosBeneficios = res.data;
        let base = process.env.VUE_APP_BASE_URL;
        for (let i = 0; i < this.ultimosBeneficios.length; i++) {
          if (
            this.ultimosBeneficios[i].logo != null &&
            this.ultimosBeneficios[i].logo
          ) {
            this.ultimosBeneficios[i].logo =
              base + this.ultimosBeneficios[i].logo;
          } else {
            this.ultimosBeneficios[
              i
            ].logo = require("@/assets/logos/img-default-actividades.png");
          }
        }
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
      });
  }

  private getCategorias() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("/listado/categorias")
      .then((res: any) => {
        let base = process.env.VUE_APP_BASE_URL;
        this.categorias = res.data;
        for (let i = 0; i < this.categorias.length; i++) {
          if (this.categorias[i].foto != null && this.categorias[i].foto) {
            this.categorias[i].foto = base + this.categorias[i].foto;
          } else {
            this.categorias[i].foto = require("@/assets/logos/masblanco.png");
          }
        }
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
      });
  }

  private irCategoria(idCategoria: any, nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "Categorias" &&
      this.$router.currentRoute.params.nombre == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "Comercios",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  private irBeneficio(idComercio: any, nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "Beneficio" &&
      this.$router.currentRoute.params.name == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "Beneficio",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  private scrollAreaFunctionComercios(info: any) {
    this.horizontalPercentageComercios = info.horizontalPercentage;
  }

  private scroll(direccion: string) {
    if (this.$refs.scrollComercios as any) {
      const size = (this.$refs.scrollComercios as any).scroll.horizontal.size;
      const position = (this.$refs.scrollComercios as any).scroll.horizontal
        .position;
      if (direccion == "derecha") {
        if (this.horizontalPercentageComercios >= 1) {
          (this.$refs.scrollComercios as any).setScrollPosition(0, 120);
        } else {
          (this.$refs.scrollComercios as any).setScrollPosition(
            position + 220,
            120
          );
        }
      } else {
        if (position - 90 < 0) {
          if (position > 0) {
            (this.$refs.scrollComercios as any).setScrollPosition(0, 120);
          } else {
            (this.$refs.scrollComercios as any).setScrollPosition(size, 120);
          }
        } else {
          (this.$refs.scrollComercios as any).setScrollPosition(
            position - 90,
            120
          );
        }
      }
    }
  }
  private autoscrollComercios() {
    this.scroll("derecha");
    setTimeout(this.autoscrollComercios, 5000);
  }
  private toLink(link) {
    if (link != "#") {
      window.open(link, "_blank");
    }
  }
}
